module.exports = __webpack_public_path__ + "237e783ed2705b9c27b10c1b3d49c43b.gif";